"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getErrorMessageNoAppIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoAppIdFoundInApp"));
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const callableChangeMyPassword = async ({ entryVars: { newPassword }, callbacks, executeProcesses, functionId, processor, }) => {
    const onError = (errorData) => {
        executeProcesses(functionId, callbacks.errorProcess, errorData);
    };
    const { currentUser } = processor.root.firebase.auth();
    if (!currentUser) {
        onError('No user is logged in');
        return;
    }
    if (!(0, valueIsString_1.default)(newPassword)) {
        onError('No new password was supplied');
        return;
    }
    if (!processor.root.isInDevelopment) {
        await currentUser.updatePassword(newPassword);
        executeProcesses(undefined, callbacks.successProcess);
        return;
    }
    const CALLABLE_NAME = 'changeMyPassword';
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        onError((0, getErrorMessageNoProjectIdFoundInApp_1.default)(CALLABLE_NAME));
        return;
    }
    const appId = processor.root.getAppId();
    if (!appId) {
        onError((0, getErrorMessageNoAppIdFoundInApp_1.default)(CALLABLE_NAME));
        return;
    }
    processor.root.cloud.rendererChangeMyPassword({
        newPassword,
        projectId,
        appId,
    }).then(({ success, message }) => {
        if (success) {
            executeProcesses(undefined, callbacks.successProcess);
        }
        else {
            onError(message);
        }
    }).catch((error) => {
        if (!(0, valueIsRecord_1.default)(error)) {
            onError('Unknown error');
        }
        else {
            onError(error.message);
        }
    });
};
exports.default = callableChangeMyPassword;
